import { render, staticRenderFns } from "./CallFlowsView.vue?vue&type=template&id=16617764"
import script from "./CallFlowsView.vue?vue&type=script&lang=js"
export * from "./CallFlowsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports